import { put, call, all, takeLatest, select } from "redux-saga/effects";
import {
  // --------------EasyInest-----------------
  REQAnalyticList,
  RESAnalyticList,
  FailAnalyticList,
  // --------------UntHld-----------------
  REQAnalyticUntHldList,
  RESAnalyticUntHldList,
  FailAnalyticUntHldList,
  // --------------PVD-----------------
  REQAnalyticPVDList,
  RESAnalyticPVDList,
  FailAnalyticPVDList,
  // --------------PVD Excel Download-----------------
  REQAnalyticPVDExcelDownload,
  RESAnalyticPVDExcelDownload,
  FailAnalyticPVDExcelDownload
} from "./actions";
import moment from "moment";
import * as actions from "../../Authentication/redux/actions";

function* fetchAnalyticListWorker({ payload }) {
  try {
    const accessToken = yield select(state => state.auth.accessToken);
    const tGUID = yield select(state => state.auth.GUID);
    const { tStartD, tEndD, bAllD } = payload;
    const tStartD1 = moment(tStartD).format("YYYY-MM-DD");
    let tEndD1 = moment(tEndD).format("YYYY-MM-DD");
    tEndD1 = tEndD1 + " 23:59";
    const request = yield fetch(
      `${process.env.REACT_APP_API_ADMIN_URL}/api/v1/admin/analyticUserAccount`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userid: tGUID,
          'x-id-token': "Bearer " + accessToken
        },
        body: JSON.stringify({
          // ---Search----
          startDate: tStartD1,
          endDate: tEndD1,
          allDate: bAllD
        })
      }
    );
    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    const response = yield request.json();

    if (response) {
      yield put(RESAnalyticList(response));
    } else {
      yield put(RESAnalyticList());
    }
  } catch (error) {

    yield put(FailAnalyticList());
  }
}

function* fetchAnalyticUntHldListWorker({ payload }) {
  try {
    const accessToken = yield select(state => state.auth.accessToken);
    const tGUID = yield select(state => state.auth.GUID);
    const { tStartD, tEndD, bAllD } = payload;
    const tStartD1 = moment(tStartD).format("YYYY-MM-DD");
    let tEndD1 = moment(tEndD).format("YYYY-MM-DD");
    tEndD1 = tEndD1 + " 23:59";
    const request = yield fetch(
      `${process.env.REACT_APP_API_ADMIN_URL}/api/v1/admin/analyticUnitHolder`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userid: tGUID,
          'x-id-token': "Bearer " + accessToken
        },
        body: JSON.stringify({
          // ---Search----
          startDate: tStartD1,
          endDate: tEndD1,
          allDate: bAllD
        })
      }
    );
    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    const response = yield request.json();

    if (response) {
      yield put(RESAnalyticUntHldList(response));
    } else {
      yield put(RESAnalyticUntHldList());
    }
  } catch (error) {

    yield put(FailAnalyticUntHldList());
  }
}

function* fetchAnalyticPVDListWorker({ payload }) {
  try {
    const accessToken = yield select(state => state.auth.accessToken);
    const tGUID = yield select(state => state.auth.GUID);
    const { tStartD, tEndD, bAllD, page = 1, per_page = 50, sort_by = 'B2C_CreateDate', sort_order = 'asc', filterType } = payload;

    const tStartD1 = moment(tStartD).format("YYYY-MM-DD");
    let tEndD1 = moment(tEndD).format("YYYY-MM-DD");
    tEndD1 = tEndD1 + " 23:59";

    const request = yield fetch(
      `${process.env.REACT_APP_API_ADMIN_URL}/api/v1/admin-actions/pvdconversion`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userid: tGUID,
          'x-id-token': "Bearer " + accessToken
        },
        body: JSON.stringify({
          startDate: tStartD1,
          endDate: tEndD1,
          allDate: bAllD,
          page,
          per_page,
          sort_by,
          sort_order,
          filterType
        })
      }
    );
    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    const response = yield request.json();

    // Map API response to expected shape for the table
    if (response && response.data && Array.isArray(response.data.data)) {
      yield put(RESAnalyticPVDList({
        results: response.data.data,
        pagination: response.data.pagination,
        summary: response.data.summary || {},
        applied_filters: response.data.applied_filters,
        message: response.data.message,
        timestamp: response.data.timestamp
      }));
    } else {
      yield put(RESAnalyticPVDList({ results: [], pagination: {}, summary: {} }));
    }
  } catch (error) {
    yield put(FailAnalyticPVDList());
  }
}

function* fetchAnalyticPVDExcelDownloadWorker({ payload }) {
  try {
    const accessToken = yield select(state => state.auth.accessToken);
    const tGUID = yield select(state => state.auth.GUID);
    const { tStartD, tEndD, bAllD, sort_by = 'B2C_CreateDate', sort_order = 'asc' } = payload;

    // Format dates as YYYY-MM-DD
    const tStartD1 = moment(tStartD).format("YYYY-MM-DD");
    const tEndD1 = moment(tEndD).format("YYYY-MM-DD");    // Build query parameters for FULL DATA (no pagination)
    const queryParams = new URLSearchParams({
      start_date: tStartD1,
      end_date: tEndD1,
      sort_by: sort_by,
      sort_order: sort_order,
      export: 'true' // Flag to indicate we want all data
    });

    // ============================================================
    // REAL API MODE - Mock data disabled for Excel download
    // ============================================================
    // ============================================================
    // REAL API CALL - Fetch ALL data without pagination
    // ============================================================
    const apiUrl = `${process.env.REACT_APP_API_ADMIN_URL}/api/pvd/pvd-report?${queryParams.toString()}`;

    console.log('🔵 PVD Excel Download API Call [REAL API]:', apiUrl);
    console.log('📦 Payload:', { tStartD1, tEndD1, sort_by, sort_order });

    const authHeaders = {
      "Content-Type": "application/json",
      "Authorization": "" // Leave blank - add token manually in browser
    };

    const request = yield fetch(apiUrl, {
      method: "GET",
      headers: authHeaders
    });

    console.log('📡 Excel Download API Response Status:', request.status); if (request.status === 401 || request.status === 403) {
      console.log('❌ Unauthorized/Forbidden:', request.status);
      console.log('💡 Add Authorization token manually using ModHeader or DevTools');
      // Commented out auto sign-out for manual testing
      // yield put(actions.autoSignOut());
      yield put(FailAnalyticPVDExcelDownload());
      return null;
    }

    const contentType = request.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      console.error('❌ Response is not JSON, content-type:', contentType);
      yield put(FailAnalyticPVDExcelDownload());
      return null;
    }

    const response = yield request.json();
    console.log('✅ Excel Download API Response Data:', response);

    let allData = [];
    if (response && response.data && response.data.results) {
      allData = response.data.results;
    } else if (response && response.results) {
      allData = response.results;
    }

    yield put(RESAnalyticPVDExcelDownload(allData));
    return allData;
  } catch (error) {
    console.error('❌ PVD Excel Download Error:', error);
    yield put(FailAnalyticPVDExcelDownload());
    return null;
  }
}

export function* analyticListSaga() {
  yield all([
    takeLatest(REQAnalyticList, fetchAnalyticListWorker),
    takeLatest(REQAnalyticUntHldList, fetchAnalyticUntHldListWorker),
    takeLatest(REQAnalyticPVDList, fetchAnalyticPVDListWorker),
    takeLatest(REQAnalyticPVDExcelDownload, fetchAnalyticPVDExcelDownloadWorker)
  ]);
}